import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ETLS3ConfigurationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ETLS3Configuration";
        this.primaryEnterpriseComponent = "ETLS3Configuration";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLS3Configuration";
        eom.enterpriseComponent = "ETLS3Configuration";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default ETLS3ConfigurationEnterpriseObjectMetadata;